import { QuoteUrlConstant } from 'src/constants';
import {
  GetQuoteChartDto,
  GetQuoteChartResponseDto,
  GetQuoteDto,
  GetQuoteListDto,
  GetQuoteListResponseDto,
  QuoteDto,
} from 'src/dtos';
import { ConfigService } from 'src/services';
import { replacePlaceholders, httpRequest } from 'src/utils';

export class QuoteApi {
  private _configService: ConfigService;
  constructor(configService: ConfigService) {
    this._configService = configService;
  }
  async list({ queryParams }: GetQuoteListDto): Promise<GetQuoteListResponseDto> {
    return httpRequest<GetQuoteListResponseDto>({
      method: 'GET',
      url: QuoteUrlConstant.LIST,
      queryParams,
      authToken: this._configService.authToken,
    });
  }

  async retrieve({ params }: GetQuoteDto): Promise<QuoteDto> {
    const url = replacePlaceholders(QuoteUrlConstant.RETRIEVE, {
      symbol: params.symbol,
    });

    return httpRequest<QuoteDto>({
      method: 'GET',
      url,
      authToken: this._configService.authToken,
    });
  }

  async retrieveChart({ params, queryParams }: GetQuoteChartDto): Promise<GetQuoteChartResponseDto> {
    const url = replacePlaceholders(QuoteUrlConstant.GET_CHART, {
      symbol: params.symbol,
    });

    return httpRequest<GetQuoteChartResponseDto>({
      method: 'GET',
      url,
      queryParams,
      authToken: this._configService.authToken,
    });
  }
}
